import { IGetListSaleDealParams } from 'interfaces/SaleDeal';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import * as SaleDealQuery from './GraphQL/Queries/saleDealQuery';
import { SALE_DEAL_VARIABLE } from './GraphQL/Variables/saleDeal';

export const SaleDealApi = {
  getListSaleDeal: async (params: IGetListSaleDealParams) => {
    return await axiosGraphQL.post('graphql', {
      query: SaleDealQuery.GET_LIST_SALE_DEAL,
      variables: SALE_DEAL_VARIABLE.getListSaleDeal(params),
    });
  },
  getListSaleDealCb: async (params: IGetListSaleDealParams) => {
    return await axiosGraphQL.post('graphql', {
      query: SaleDealQuery.GET_LIST_SALE_DEAL_CB,
      variables: SALE_DEAL_VARIABLE.getListSaleDeal(params),
    });
  },
  getListConditionTypeCb: async (params: IGetListSaleDealParams) => {
    return await axiosGraphQL.post('graphql', {
      query: SaleDealQuery.GET_LIST_CONDITION_TYPE_CB,
      variables: SALE_DEAL_VARIABLE.getListSaleDeal(params),
    });
  },
};
